import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';

@Component({
  selector: 'app-master-form-popup',
  templateUrl: './master-form-popup.component.html',
  styleUrls: ['./master-form-popup.component.scss']
})
export class MasterFormPopupComponent implements OnInit {
  files: any;
  formBuilder: any;

  constructor(
    public dialogRef: MatDialogRef<MasterFormPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public addData: any,
    private fb: FormBuilder,
    private commonService: CommonServiceService,
    private snackBar: MatSnackBar,
  ) {
    this.getCountry();
    this.intilizeForms();
  }
  countryForm !: FormGroup;
  sectorForm !: FormGroup;
  libraryForm!: FormGroup;
  msmeForm!: FormGroup;
  msmeClassificationForm!: FormGroup;
  countryList: any = [];
  sectorList: any = [];
  userId: any = '';
  imgURL = '';
  imageAllData: any = [];
  putAPIurl: any;
  payloadURL = '';
  isEditMode = false;
  @ViewChild('fileSet', { static: true }) fileSet: any;
  @ViewChild('fileDropRef', { static: false }) fileDropRef!: ElementRef;
  fileUploadInfo = '*File size limit: 5MB*';

  ngOnInit(): void {
    this.isEditMode = this.addData?.edit;
    this.payloadURL = this.imgURL = this.addData?.rowData?.country_icons ? this.addData?.rowData?.country_icons : '';
    const userData: any = (sessionStorage.getItem('userdata'));
    this.userId = JSON.parse(userData)?.id;

  }
  close(): void {
    this.dialogRef.close();
  }
  intilizeForms(): void {
    if (this.addData?.data?.key === 'countryMaster') {
      this.initilizeCountryForm();
    }else if (this.addData?.data?.key === 'sectorMaster'){
      this.initilizeSectorForm();
    }else if (this.addData?.data?.key === 'msmeClassificationMaster'){
      this.initilizeMsmeClassificationForm();
    }else{
      this.initilizeMsmeForm();
    }
  }
  initilizeCountryForm(): void {
    this.countryForm = this.fb.group({
      name: ['', Validators.required],
      countryImage : ['', Validators.required]
    });
    if (this.addData?.rowData){
      this.countryForm.patchValue({
        name: this.addData?.rowData?.name,
        countryImage: this.addData?.rowData?.country_icons
      });
    }
  }

  initilizeSectorForm(): void {
    this.sectorForm = this.fb.group({
      name: ['', Validators.required],
      country_id: ['', [Validators.required]],
    });
    if (this.addData?.rowData){
      this.sectorForm.patchValue({
        name: this.addData?.rowData?.name,
        country_id: this.addData?.rowData?.country_id
      });
    }
  }
  initilizeMsmeForm(): void {
    this.msmeForm = this.fb.group({
      name: ['', Validators.required],
      country_id: ['', [Validators.required]],
      sector_id: ['', Validators.required],
    });
    if (this.addData?.rowData){
      this.msmeForm.patchValue({
        name: this.addData?.rowData?.name,
        country_id: this.addData?.rowData?.['sector.country.id'],
        sector_id: this.addData?.rowData.sector_id
      });
      if (this.addData?.rowData?.['sector.country.id']){
        this.getSector(this.addData?.rowData?.['sector.country.id']);
      }

    }
  }

  initilizeMsmeClassificationForm(): void {
    this.msmeClassificationForm = this.fb.group({
      rows: this.fb.array([]),
    });

    // Load all existing MSME classifications so they can be edited together.
    this.commonService.formGetMethod('msme-classification/list', { fetched: 'all' }).subscribe(
      (res: any) => {
        const list = res?.data || [];
        list.forEach((item: any) => {
          this.msmeClassRows.push(
            this.fb.group({
              id: [item?.id],
              type: [item?.type, Validators.required],
              min_employee_count: [item?.min_employee_count, [Validators.required]],
              max_employee_count: [item?.max_employee_count, [Validators.required]],
            })
          );
        });

        // Keep subsequent row min_employee_count = previous row max_employee_count + 1
        this.msmeClassRows.controls.forEach((group: any, index: number) => {
          const currentMaxControl = group.get('max_employee_count');
          if (!currentMaxControl) {
            return;
          }

          currentMaxControl.valueChanges.subscribe((value: any) => {
            const nextGroup = this.msmeClassRows.at(index + 1) as FormGroup | undefined;
            if (!nextGroup) {
              return;
            }

            const nextMinControl = nextGroup.get('min_employee_count');
            if (!nextMinControl) {
              return;
            }

            const numericValue = Number(value);
            if (!Number.isFinite(numericValue)) {
              return;
            }

            nextMinControl.setValue(numericValue + 1, { emitEvent: false });
          });
        });
      },
      (error: any) => {
        this.openSnackBar([error?.error?.message || 'Failed !'], '');
      }
    );
  }

  get msmeClassRows(): FormArray {
    return this.msmeClassificationForm.get('rows') as FormArray;
  }

  getCountry(): void {
    this.commonService.formGetMethod('country/list?fetched=all', {}).subscribe((res: any) => {
      this.countryList = res?.data;
    },
      (error: any) => {
        this.openSnackBar([error?.error?.message || 'Failed !'], '');
      }
    );
  }
  getSector(id: any): void {
    const params: any = {};
    if (id !== null){
      params.country_id = id;
    }

    this.commonService.formGetMethod('sector/list', params).subscribe((res: any) => {
      this.sectorList = res?.data;
    },
      (error: any) => {
        this.openSnackBar([error?.error?.message || 'Failed !'], '');
      });
  }

  createCountryForm(): void {
    const payload = {
      name: this.countryForm?.controls.name?.value,
      country_icons: this.payloadURL,
      createdBy: this.userId,
    };
    const apiEndPoints = this.addData?.rowData ? `country/update/${this.addData?.rowData?.id}` : 'country/create';
    if (!this.countryForm?.invalid) {
      this.commonService.formPostMethod(payload, apiEndPoints).subscribe((res: any) => {
        this.openSnackBar([res?.message || 'Success !'], '', 'success');
        this.dialogRef.close({event: 'dataAdded'});
      },
        (error: any) => {
          this.openSnackBar([error?.error?.message || 'Failed !'], '');
        });
    }
  }
  createSectorForm(): void {
    const payload = {
      name: this.sectorForm?.controls.name?.value,
      country_id: this.sectorForm?.controls.country_id?.value,
      createdBy: this.userId
    };
    const apiEndPoints = this.addData?.rowData ? `sector/update/${this.addData?.rowData?.id}` : 'sector/create';
    if (!this.sectorForm?.invalid) {
      this.commonService.formPostMethod(payload, apiEndPoints).subscribe((res: any) => {
        this.openSnackBar([res?.message || 'Success !'], '', 'success');
        this.dialogRef.close({event: 'dataAdded'});
      },
        (error: any) => {
          this.openSnackBar([error?.error?.message || 'Failed !'], '');
        });
    }
  }
  createMsmeForm(): void {
    const payload = {
       name: this.msmeForm?.controls.name?.value,
      country_id: this.msmeForm?.controls.country_id?.value,
      sector_id: this.msmeForm?.controls.sector_id?.value,
      createdBy: this.userId
    };
    const apiEndPoints = this.addData?.rowData ? `msme/update/${this.addData?.rowData?.id}` : 'msme/create';
    if (!this.sectorForm?.invalid) {
      this.commonService.formPostMethod(payload, apiEndPoints).subscribe((res: any) => {
        this.openSnackBar([res?.message || 'Success !'], '', 'success');
        this.dialogRef.close({event: 'dataAdded'});
      },
        (error: any) => {
          this.openSnackBar([error?.error?.message || 'Failed !'], '');
        });
    }
  }

  createMsmeClassificationForm(): void {
    if (!this.msmeClassificationForm || this.msmeClassificationForm.invalid) {
      return;
    }

    const payload = this.msmeClassRows.controls.map((group: any) => ({
      id: group?.get('id')?.value,
      type: group?.get('type')?.value,
      min_employee_count: Number(group?.get('min_employee_count')?.value),
      max_employee_count: Number(group?.get('max_employee_count')?.value),
      createdBy: this.userId,
    }));

    if (!payload.length) {
      return;
    }

    this.commonService.formPostMethod(payload, 'msme-classification/update/bulk').subscribe(
      (res: any) => {
        this.openSnackBar([res?.message || 'Success !'], '', 'success');
        this.dialogRef.close({ event: 'dataAdded' });
      },
      (error: any) => {
        this.openSnackBar([error?.error?.message || 'Failed !'], '');
      }
    );
  }

  openSnackBar(message: any, action = '', className = 'parmary'): void {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: [className]
    });
  }
  countryChanges(e: any): void {
    const id = e.value;
    this.getSector(id);
  }
  onFileDropped(event: any): void {
    this.files = [];
    this.prepareFilesList(event);
  }
  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>): void {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }
  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number): void {
      setTimeout(() => {
        if (index === this.files.length) {
          return;
        } else {
          const progressInterval = setInterval(() => {
            if (this.files[index].progress === 100) {
              clearInterval(progressInterval);
              this.uploadFilesSimulator(index + 1);
            } else {
              this.files[index].progress += 5;
            }
          }, 200);
        }
      }, 1000);
    }
  /**
   * handle file from browsing
   */
  fileBrowseHandler(files: any): void {
        const maximumFileSize = 5 * 1024 * 1024; // 5MB in bytes
        const currentFileSize = files?.target?.files[0]?.size;

        if (currentFileSize > maximumFileSize){
          files.target.value = null;
          this.openSnackBar(['Please upload file under 5 MB !'] , '');
          return ;
        }

        const payload = [{
            file_name: files.target.files[0].name,
            mime_type: files.target.files[0].type
          }];
        this.commonService.uploadImage(payload).subscribe((res: any) => {
            if (res.success){
              this.imageAllData = res.data;
              this.imageAllData.forEach((ele: any) => {
                this.putAPIurl = ele?.url;
                this.payloadURL = ele?.file_url;
                this.imgURL = ele?.file_url;
              });
              this.commonService.imagePUTapi(this.putAPIurl, files.target.files[0]).subscribe();
            }
          });

        this.files = [];
        this.prepareFilesList(files.target.files);
      }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number): void {
      if (this.fileDropRef) {
        this.fileDropRef.nativeElement.value = '';
      }

      this.files?.splice(index, 1);
      this.imgURL = '';
      this.payloadURL = '';
      if (this.files.length === 0) {
        this.libraryForm.reset();
        this.libraryForm.get('files')?.reset();
      }
    }

  openDocument(): void {
    window.open(this.imgURL);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
